module.exports = __webpack_public_path__ + "static/egyptian-cotton-duvet-cover-chalk-1-35370ee4b5fb19dc73ec0aeed82b394b.webp";